import cookieUtil from 'tradera-utils/cookie';
import actionTypes from './action-types';
import { resolveCurrency } from './helpers';

const yearInMilliseconds = 1000 * 60 * 60 * 24 * 365;

const createPreferredCurrencyCookie = currencyCode => {
    cookieUtil.createCookie(
        'preferred_currency',
        currencyCode,
        new Date(new Date().getTime() + yearInMilliseconds)
    );
};

export default (state = {}, action) => {
    const setPreferredCurrency = () => {
        createPreferredCurrencyCookie(action.payload.currencyCode);
        const { enabled, currencies } = state;
        return {
            ...state,
            preferredCurrency: resolveCurrency(
                enabled,
                action.payload.currencyCode,
                currencies
            )
        };
    };

    const setCurrencyIfNotChosen = () => {
        if (cookieUtil.readCookie('preferred_currency')) {
            return state;
        }
        createPreferredCurrencyCookie(action.payload.currencyCode);
        const { enabled, currencies } = state;
        return {
            ...state,
            preferredCurrency: resolveCurrency(
                enabled,
                action.payload.currencyCode,
                currencies
            )
        };
    };

    const def = () => state;

    const reducers = {
        [actionTypes.SET_PREFERRED_CURRENCY]: setPreferredCurrency,
        [actionTypes.SET_CURRENCY_IF_NOT_CHOSEN]: setCurrencyIfNotChosen
    };

    return !state.enabled || !action || !action.type || !reducers[action.type]
        ? def()
        : reducers[action.type]();
};
